import { PatientRecordDTO } from '../../interface/interface';

//Datos mínimos del paciente para recetar. Sin alguno, el paso Paciente de la receta lo manda a completarlos (Editar paciente)
export function isValidPatientRecord(dto: PatientRecordDTO): boolean {
    if (!dto.firstname || dto.firstname.trim() === '') return false;
    if (!dto.lastname || dto.lastname.trim() === '') return false;
    if (!dto.document || dto.document.trim() === '') return false;
    if (!dto.gender || dto.gender.trim() === '') return false;
    if (!dto.birthdate || (typeof dto.birthdate === 'string' && dto.birthdate.trim() === '')) return false;

    return true;
}
